// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { createSelector } from 'reselect';

import { RootState } from '../../rootReducer';

export const readSupportListRaw = (state: RootState) => state.updateReadSupportReducer;

export const makeUpdateReadSupportSelector = () => {
  return createSelector(
    readSupportListRaw,
    (updateReadSupportReducer) => updateReadSupportReducer.read || false
  );
}
export const makeUpdateReadSupportError = () => {
  return createSelector(
    readSupportListRaw,
    (supportReducerListReducer) => supportReducerListReducer.error
  );
}

export const makeUpdateReadSupportIsLoading = () => {
  return createSelector(
    readSupportListRaw,
    (updateReadSupportReducer) => updateReadSupportReducer.isLoading
  );
}
